export const ApplicationStatuses = [
  {
    id: 'waiting_for_soil',
    name: '土壌待ち',
  },
  {
    id: 'waiting_for_diagnosis',
    name: '分析待ち',
  },
  {
    id: 'waiting_for_delivery',
    name: '配信待ち',
  },
  {
    id: 'completed',
    name: '完了',
  },
  {
    id: 'canceled',
    name: '取り消し済み',
  },
];

export const FormBoolean = [
  {
    id: 'true',
    name: '要',
  },
  {
    id: 'false',
    name: '不要',
  },
];
